export const CHECKOUT_MAXLEN = {
    vchNombreCupon: 50,
    vchMail: 128,
    vchNombre: 100,
    vchApellido: 100,
    vchDocumento: 15,
    vchCuit: 13,
    vchRazonSocial: 200,
    vchCodigoArea: 10,
    vchTelefono: 50,

    vchCalle: 200,
    vchCalleNro: 20,
    vchPisoDpto: 40,
    vchCP: 10,
    vchDescLocalidad: 100,
} as const;
